//@mui
import { CircularProgress, Grid2 } from "@mui/material";
//@dependencies
import PropTypes from "prop-types";
//styles
import styles from "./DevToolsCard.module.scss";
// Icons
import { ReactComponent as ToggleOn } from "../../../../AdminAssets/svg/ToggleOn.svg";
import { ReactComponent as ToggleOff } from "../../../../AdminAssets/svg/ToggleOff.svg";

export default function DevToolsCard(props) {
  //props and hooks
  const {
    title,
    subTitle,
    src,
    status,
    onChange,
    button,
    onClick,
    imageSrc,
    customText,
    loading,
    hideToggle,
  } = props;

  return (
    <Grid2
      className={
        status ? styles.devToolCardContainer1 : styles.devToolCardContainer
      }
    >
      <Grid2 className={styles.displayflex}>
        <Grid2 className={styles.titleFlex}>
          <Grid2 className={styles.title}>{title}</Grid2>
          <Grid2 className={styles.title}>
            {imageSrc ? (
              <img src={imageSrc} alt={title} className={styles.cdnImage} />
            ) : (
              ""
            )}
          </Grid2>
        </Grid2>
        <Grid2>
          {loading ? (
            <CircularProgress size={22} thickness={4} />
          ) : src ? (
            <img src={src} alt={title} className={styles.cdnImage} />
          ) : button ? (
            <Grid2 className={styles.button} onClick={onClick}>
              {button}
            </Grid2>
          ) : customText ? (
            <Grid2 style={{ color: "#135fc2", fontWeight: "500" }}>
              {customText}
            </Grid2>
          ) : hideToggle ? (
            ""
          ) : (
            <Grid2 onClick={onChange} style={{ cursor: "pointer" }}>
              {status ? <ToggleOn /> : <ToggleOff />}
            </Grid2>
          )}
        </Grid2>
      </Grid2>
      <Grid2 className={styles.subTitle}>{subTitle}</Grid2>
    </Grid2>
  );
}
// PropTypes
DevToolsCard.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  status: PropTypes.bool,
  onChange: PropTypes.func,
  src: PropTypes.string,
  hideToggle: PropTypes.bool,
};
